(() => {
  const title = 'FREE T-SHIRT WITH £120';
  const root = window.Shopify?.routes?.root || '/';
  let cataloguePromise, syncing = false, latestCart;
  const rate = () => Number(window.Shopify?.currency?.rate) || 1;
  const threshold = () => Math.round(12000 * rate());
  const gift = item => item.properties?._hcx_free_tee_120 === 'true';
  const allocation = item => (item.line_level_discount_allocations || []).filter(a => a.discount_application?.title === title).reduce((n,a) => n + a.amount, 0);
  const money = (cents, currency = latestCart?.currency || 'GBP') => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency,minimumFractionDigits:cents % 100 === 0 ? 0 : 2,maximumFractionDigits:2}).format(cents / 100);
  const request = async (path, body) => {
    const response = await fetch(root + path, {method:body?'POST':'GET',headers:{Accept:'application/json','Content-Type':'application/json'},body:body?JSON.stringify(body):undefined});
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error(data.description || 'Please try again.');
    return data;
  };
  const catalogue = url => cataloguePromise ||= fetch(url).then(r => {if(!r.ok)throw Error('Unable to load the free tees.');return r.json();});
  const spend = (cart, data) => cart.items.reduce((total,item) => {
    if(gift(item) || data.giftCardIds.includes(item.product_id))return total;
    const productDiscounts = (item.line_level_discount_allocations || []).reduce((n,a) => n + a.amount, 0);
    return total + Math.max(0, item.original_line_price - productDiscounts);
  },0);
  const freeApplied = cart => cart.items.some(item => allocation(item) > 0);
  const freeAmount = cart => cart.items.reduce((n,item)=>n+allocation(item),0);
  const sections = () => ['cart-drawer','cart-icon-bubble', ...[...document.querySelectorAll('#main-cart-items,#main-cart-footer')].map(el=>el.dataset.id).filter(Boolean)];
  function renderCart(cart) {
    const drawer = document.querySelector('cart-drawer');
    if(cart.sections?.['cart-drawer'] && typeof drawer?.renderContents==='function') {
      drawer.renderContents(cart);
      drawer.classList.toggle('is-empty',cart.item_count===0);
    }
    for(const [key,markup] of Object.entries(cart.sections || {})) {
      if(!markup || key==='cart-drawer')continue;
      const target=key==='cart-icon-bubble'?document.getElementById(key):document.getElementById('shopify-section-'+key);
      if(!target)continue;
      const doc=new DOMParser().parseFromString(markup,'text/html');
      const source=key==='cart-icon-bubble'?doc.querySelector('.shopify-section'):doc.getElementById('shopify-section-'+key);
      if(source)target.innerHTML=source.innerHTML;
    }
    if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'hcx-free-tee',cartData:cart});
  }
  async function sync(cart) {
    if(syncing)return;
    syncing=true;
    try {
      const element=document.querySelector('hcx-free-tee');
      if(!element)return;
      const data=await catalogue(element.dataset.catalogUrl);
      if(!cart?.items)cart=await request('cart.js');
      const marked=cart.items.filter(gift),updates={};
      let kept=false;
      for(const item of marked) {
        const valid=spend(cart,data)>=threshold() && freeAmount(cart)>=item.original_price;
        if(!valid || kept)updates[item.key]=0;
        else {kept=true;if(item.quantity!==1)updates[item.key]=1;}
      }
      if(Object.keys(updates).length) {
        cart=await request('cart/update.js',{updates,sections:sections(),sections_url:location.pathname});
        renderCart(cart);
      }
      latestCart=cart;
      await Promise.all([...document.querySelectorAll('hcx-free-tee')].map(el=>el.update(cart,data)));
    } catch(error) {
      document.querySelectorAll('hcx-free-tee').forEach(el=>el.error('Could not refresh the free tee offer. Please refresh your cart.'));
    } finally {syncing=false;}
  }
  class FreeTee extends HTMLElement {
    connectedCallback() {
      const initial=JSON.parse(this.querySelector('[data-gift-cart]').textContent);
      catalogue(this.dataset.catalogUrl).then(data=>this.update(latestCart || initial,data)).catch(()=>{});
    }
    error() {}
    update(cart,data) {
      const amount=spend(cart,data),remaining=Math.max(0,threshold()-amount);
      const progress=Math.min(100,Math.round(amount*100/threshold()));
      const bar=this.querySelector('[role="progressbar"]');bar.setAttribute('aria-valuenow',progress);bar.firstElementChild.style.width=progress+'%';
      const copy=remaining>0?`Spend ${money(remaining,cart.currency)} more for a free T-shirt`:'Free T-shirt unlocked';
      this.querySelector('[data-gift-copy]').textContent=copy;
      bar.setAttribute('aria-valuetext',copy);
    }
  }
  customElements.define('hcx-free-tee',FreeTee);
  if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{if(event.source!=='hcx-free-tee')sync(event.cartData);});
  // Recheck a saved cart on load; gift lines never remain as paid extras after losing eligibility.
  sync();
})();
